export const listaPriorita = [
  { valore: 50, descrizione: "Bassa" },
  { valore: 20, descrizione: "Media" },
  { valore: 10, descrizione: "Alta" },
  { valore: 1, descrizione: "Altissima" },
];